import { SelectionModel } from '@angular/cdk/collections';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from 'src/app/icon/icon.module';
import { ITopAction } from 'src/app/shared/interfaces/ITable';
import { TableLayout } from 'src/app/shared/enums';

@Component({
  selector: 'app-table-actions',
  standalone: true,
  imports: [CommonModule, IconModule, MatButtonModule, TranslateModule],
  templateUrl: './table-actions.component.html'
})
export class TableActionsComponent {
  readonly TableLayout = TableLayout;
  @Input() actions?: ITopAction[];
  @Input() selection: SelectionModel<any>;
  @Input() layout: TableLayout = TableLayout.CLASSIC;
}
